export default __webpack_public_path__ + "static/media/Active Wear & Inner Wear.b9564e82.jpg";